import { useEffect } from 'react';
import { Outlet } from 'react-router';

import useAppNavigate from '@/shared/hooks/useAppNavigation';
import { setNavigate } from '@/shared/services/helpers/navigate-helper';
import { useAppSelector } from '@/store/store';

import { LanguageGuard } from './language.guard';

const AppProvider: React.FC = () => {
  const { headerConfig } = useAppSelector((state) => state.app);

  const { navigate } = useAppNavigate();
  setNavigate(navigate);

  useEffect(() => {
    document.title =
      'Online TD' +
      (headerConfig.helmetTitle ? ` | ${headerConfig.helmetTitle}` : '');
  }, [headerConfig.helmetTitle]);

  return (
    <LanguageGuard>
      <Outlet />
    </LanguageGuard>
  );
};

export default AppProvider;
